// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingList.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React, { Component } from 'react';
import { Table, Column, ColumnGroup } from 'share/components/controls/DataGrid/Izenda.Table';
import {
  TableDefinition,
  REQUIRED_VALIDATION_RULES,
  KEY_TO_DATABASE_NAME,
  KEY_TO_SCHEMA,
  DEFAULT_DATABASE_MAPPING_HEIGHT
} from 'logic/data/Izenda.ImportConstants';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';
import Validator from 'share/components/hoc/Izenda.Validator';
import actions from './Izenda.DatabaseMappingListActions';
import connect from 'share/enhancers/Izenda.Connect';
import { forEach } from 'lodash/fp';

const SelectValidator = Validator()(Select);
const TABLE_DEF = TableDefinition.DatabaseMappingSourceType;

@connect(actions)
export default class DatabaseMappingList extends Component {
  constructor(props) {
    super(props);
  }

  renderDatabaseNameFrom = (data: any) => {
    const { fromDatabaseName, serverType } = data;
    const label = `[${serverType}] ${fromDatabaseName}`;
    return (
      <span className='truncate overflow-text' title={label}>
        {label}
      </span>
    );
  };

  renderSchemaFrom = ({ fromSchema }) => {
    return (
      <span className='truncate overflow-text' title={fromSchema}>
        {fromSchema}
      </span>
    );
  };

  renderDatabaseNameTo = (data: any, columnKey: string, index: number) => {
    const { selectedToDatabaseNameId } = data;
    let databaseNamesTo = this.props.store.databaseNamesTo;
    forEach(item => {
      item.label = `[${item.serverTypeName}] ${item.name}`;
    }, databaseNamesTo);

    return (
      <SelectValidator
        scalable={false}
        options={databaseNamesTo}
        simpleValue
        labelKey='label'
        valueKey='id'
        value={selectedToDatabaseNameId}
        onChange={this.props.onChangeToDatabaseName.bind(this, data)}
        validations={REQUIRED_VALIDATION_RULES}
        field={KEY_TO_DATABASE_NAME}
        group={index.toString()}
      />
    );
  };

  renderSchemaTo = (data: any, columnKey: string, index: number) => {
    const { selectedToSchemaId, toSchemas } = data;

    return (
      <SelectValidator
        scalable={false}
        simpleValue
        options={toSchemas}
        labelKey='value'
        valueKey='key'
        value={selectedToSchemaId}
        onChange={data.setSelectedToSchema.bind(data)}
        validations={REQUIRED_VALIDATION_RULES}
        field={KEY_TO_SCHEMA}
        group={index.toString()}
      />
    );
  };

  render() {
    const { localization, store } = this.props;
    const newHeight = DEFAULT_DATABASE_MAPPING_HEIGHT;

    return (
      <div>
        {/* Header */}
        <div className='panel-heading u-bgWhite'>
          <strong> {localization.getText('CONTEXT_MENU_LABEL_DATABASE_MAPPING')}</strong>
        </div>
        {/* Grid */}
        <div className='u-bgWhite'>
          <Table minHeight={newHeight} maxHeight={newHeight} dataSource={store.model.databaseMappings} sortInfo>
            {/* GROUP TABLE FROM */}
            <ColumnGroup title={localization.getText('COMMON_LABEL_FROM')}>
              <Column {...TABLE_DEF['physicalDatabase']} cell={this.renderDatabaseNameFrom} />
              <Column {...TABLE_DEF['schema']} cell={this.renderSchemaFrom} />
            </ColumnGroup>
            {/* GROUP TABLE TO */}
            <ColumnGroup title={localization.getText('COMMON_LABEL_TO')}>
              <Column {...TABLE_DEF['databaseName']} cell={this.renderDatabaseNameTo} />
              <Column {...TABLE_DEF['schema']} cell={this.renderSchemaTo} />
            </ColumnGroup>
          </Table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/DatabaseMapping/Izenda.DatabaseMappingList.js